import React from 'react';

import { QuickBooks } from './Billing/QuickBooks';
import Location from '../../../../helpers/uiComponents/Location';
import Contact from '../../../../helpers/uiComponents/Contact';
import AccordianTitle from '../../../../helpers/uiComponents/Accordian';

class BillingInformation extends React.Component {
    render() {
        const currentClient = this.props.currentClient;
        const contacts = currentClient.contacts.filter( cont => { return cont.type === "billing"; });
        const locations = currentClient.locations.filter( loc => { return loc.type === "billing" && loc.clientCode === currentClient.clientCode });

        return(
            <div className="input-group">
                <AccordianTitle title={"Billing Information"} />
                <div className="accordian-body">
                    <h4>Billing Information</h4>
                    {(currentClient) && (
                        <QuickBooks
                            clientCode={currentClient.clientCode}
                        />
                    )}
                    
                    <h4>Billing Address</h4>
                    <Location
                        locations={locations}
                        clientCode={currentClient.clientCode}
                        type={"billing"}
                        container={"billing-location"}
                    />

                    <h4>Billing Contacts</h4>
                    <Contact
                        contacts={contacts}
                        clientCode={currentClient.clientCode}
                        type={"billing"}
                        container={"billing-contact"}
                    />
                </div>
            </div>
        )
    }
}
export default BillingInformation;


// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/ProfileComponents/BillingInformation.js